import { render, staticRenderFns } from "./CampaignEmailFilter.vue?vue&type=template&id=61b7f434&scoped=true&"
import script from "./CampaignEmailFilter.vue?vue&type=script&lang=js&"
export * from "./CampaignEmailFilter.vue?vue&type=script&lang=js&"
import style0 from "./CampaignEmailFilter.vue?vue&type=style&index=0&id=61b7f434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b7f434",
  null
  
)

export default component.exports